import React, { useState,useEffect } from 'react'
import Sidennav from "../dashboard/sidenavbar";
import Topnavbar from "../dashboard/topnavbar";
import { NavLink, useNavigate } from 'react-router-dom';
import { baseurladdress } from "../baseurl";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';

function Editshiftassignment() {
    const Swal = require("sweetalert2");
    const navigate=useNavigate();
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const { staff_id } = useParams();
    const [staff_name,setstaff_name]=useState("");
    const [staff_code,setstaff_code]=useState("");
    const [staff_dept,setstaff_dept]=useState("");
    const [staff_deptcode,setstaff_deptcode]=useState("");
    const [staff_deptid,setstaff_deptid]=useState("");
    const [staff_typename,setstaff_typename]=useState("");
    const [x, setX] = useState("");
    const [xy, setXY] = useState("");
    const [staff_typeid,setstaff_typeid]=useState("");
    const [staff_branchshift, setstaff_branchshift] = useState([]);
    const [status,setstaff_status]=useState("");
    const [shiftFrom,setShiftfrom]=useState("");
    const [shiftTo,setShiftTo]=useState("");
    const [staffBranch,setStaffBranch]=useState(""); 
    const [staffBranchid,setStaffBranchid]=useState(""); 
   

    useEffect(() => {
        axios
            .get(baseurladdress + `editshiftassign/` + staff_id, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                const data = res.data.response;
                setstaff_name(data[0].assign_staffname);
                setstaff_code(data[0].assign_staffcode);
                setstaff_dept(data[0].assign_deptname);
                setstaff_deptcode(data[0].assign_deptcode);
                setstaff_deptid(data[0].assign_deptid);
                setstaff_typeid(data[0].assign_shifttypeid);
                setstaff_typename(data[0].asign_shiftname);
                setXY(data[0].assign_status);
                setStaffBranch(data[0].assign_branchname);
                setStaffBranchid(data[0].assign_branchid);
                setstaff_branchshift(data[0].assign_shifttypeid)
                const check = (data[0].assign_status == "1") ? true : false;
                setX(check);
                const fromDate=moment(data[0].assing_fromdate).format("YYYY-MM-DD");
                const toDate=moment(data[0].assign_todate).format("YYYY-MM-DD");
                setShiftfrom(fromDate);
                setShiftTo(toDate);
                // setShiftfrom(data[0].assing_fromdate);
                // setShiftTo(data[0].assign_todate);
                getshifttype();
            });
    }, [staff_id]
    );
    // const getshifttype = () => {
    //     axios.get(baseurladdress + `getallshifttype`, {
    //         headers: { Authorization: `Bearer ${accesstoken}` },
    //     })
    //     .then(res => {
    //         const data = res.data.response;
    //         console.log(data);
    //         const user = data.map((item, index) => {
    //             var selectedd = (item.type_id == staff_typeid
    //             ) ? ' selected' : '';
    //             return (
    //                 <option value={item.type_id} selected={selectedd}> {item.type_name} </option>
    //             )
    //         }
    //         );
    //         setstaff_branchshift(user);
    //     }).catch(error => {
    //         alert(error);
    //     })
    // }


    const getshifttype = () => {
        axios.get(baseurladdress + `getallshifttype`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
        .then(res => {
            const data = res.data.response;
            console.log(data);
            const user = data.map((item) => (
                <option key={item.type_id} value={item.type_id}>
                    {item.type_name}
                </option>
            ));
            setstaff_branchshift(user);
        })
        .catch(error => {
            alert(error);
        });
    }
    

// update shift assignment datas
    const handleUpdateAssignment=(e)=>{
        e.preventDefault();
        var data={
            assign_staffid:staff_id,
            assign_staffname:staff_name,
            assign_staffcode:staff_code,
            assign_branchid:staffBranchid,
            assign_branchname:staffBranch,
            assign_deptid:staff_deptid,
            assign_deptname:staff_dept,
            assign_deptcode:staff_deptcode,
            assign_shifttypeid:staff_typeid,
            asign_shiftname:staff_typename,
            assing_fromdate:shiftFrom,
            assign_todate:shiftTo,
            assign_status:status,
            assign_updby:accessuserid
        };
        axios.post(baseurladdress+ `addshiftAssignment`,data,{
              headers:{Authorization:`Bearer ${localStorage.getItem("token")}` },
            })
            .then((result) => {
                    console.log("reslt:", result);
                    const Data = result.data.status;
                    if (Data == "success") {
                      const Toast = Swal.mixin({
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                          toast.addEventListener("mouseenter", Swal.stopTimer);
                          toast.addEventListener("mouseleave", Swal.resumeTimer);
                        },
                      });
                      Toast.fire({
                        icon: "success",
                        title: "Shift Type Data Updated successfully",
                      });
                      navigate("/shiftassignment");
                    }
                    else {
                      alert("Failed");
                    }
                  })
                  .catch((error) => {
                    alert(error);
                  });
    }
  
    return (
    <div>
            <Topnavbar />
            <Sidennav />
            <div class="content-wrap" style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                <div className="container-fluid">
                    <NavLink activeClassName="active-link" to={"/shiftassignment"}>
                        <div style={{ display: "flex" }}>
                            <a class="float">
                                <i class="fa fa-arrow-left my-float" style={{ "marginTop": "21px" }}></i>
                            </a>
                        </div>
                    </NavLink>
                    <form>
                        <div className='row'>
                            <div class="col-xl-12 col-xxl-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h4 class="card-title">EDIT SHIFT ASSIGNMENT</h4>
                                    </div>
                                    <div class="card-body">
                                        <div class="basic-form mt-3">

                                            <div class="form-row">
                                                <div class="col-sm-2 mt-2 mt-sm-0">
                                                    <h6>Staff Code</h6>
                                                    <input type="text"
                                                        class="form-control" value={staff_code}
                                                        required readOnly
                                                    />
                                                </div>
                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Staff Name</h6>
                                                    <input type="text"
                                                        class="form-control" value={staff_name}
                                                        required readOnly
                                                    />
                                                </div>

                                                <div class="col-sm-3 mt-2 mt-sm-0">
                                                    <h6>Branch</h6>
                                                    <input type="text"
                                                        class="form-control" value={staffBranch} 
                                                        required  readOnly
                                                        
                                                    />
                                                </div>
                                                <div class="col-sm-3 mt-2 mt-sm-0">
                                                    <h6>Department</h6>
                                                    <input type="text"
                                                        class="form-control" value={staff_dept}
                                                        required readOnly
                                                        
                                                    />
                                                </div>

                                                {/* <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Shift Type</h6>
                                                    <select
                                                        className="form-control select"
                                                        name="Shifttype"
                                                        value={staff_typeid}
                                                        onChange={(e) => { getshifttype(e.target.value);setstaff_typeid(e.target.value)}}
                                                    >
                                                        <option value="" disabled >
                                                            Select
                                                        </option>
                                                        {staff_branchshift}
                                                    </select>
                                                </div> */}
                                                <div className="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Shift Type</h6>
                                                    <select
                                                        className="form-control select"
                                                        name="Shifttype"
                                                        value={staff_typeid}
                                                        onChange={(e) => {
                                                            const selectedId = e.target.value;
                                                            const selectedName = e.target.options[e.target.selectedIndex].text;
                                                            setstaff_typeid(selectedId);              // Update ID
                                                            setstaff_typename(selectedName);          // Update typename
                                                            getshifttype(selectedId, selectedName);   // Optional: pass both if needed
                                                        }}
                                                    >
                                                        <option value="" disabled>
                                                            Select
                                                        </option>
                                                        {staff_branchshift}
                                                    </select>
                                                </div>

                                                <div class="col-sm-3 mt-2 mt-sm-0">
                                                    <h6>From Date</h6>
                                                    <input type='date' class="form-control"  value={shiftFrom}
                                                        required onChange={(e)=>setShiftfrom(e.target.value)}  min={new Date().toISOString().split("T")[0]}
                                                    />
                                                </div>
                                                <div class="col-sm-3 mt-2 mt-sm-0">
                                                    <h6>To Date</h6>
                                                    <input type="date" class="form-control" value={shiftTo}
                                                        required onChange={(e)=>setShiftTo(e.target.value)} min={shiftFrom}
                                                    />
                                                </div>
                                                <div class="col-sm-2 mt-2 mt-sm-0">
                                                    <br />
                                                    <input  type="checkbox" name="dept_status" className="selectsingle checku" checked={x} value={xy} id="exampleCheck1"/>
                                                    <label className="form__label textal ml-2" for="clienttype">
                                                        Status
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 offset-6 mt-4">
                                        <button type="button" class="btn btn-primary mb-2" onClick={handleUpdateAssignment} >Update</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>
  )
}

export default Editshiftassignment